import { useLanguage } from '../../hooks/useLanguage';

export const Manifest = () => {
  const { t } = useLanguage();

  return (
    <section
      id="manifest"
      className="flex items-center min-h-screen px-6 py-20 room"
      role="region"
      aria-label="Manifest"
    >
      <div className="container max-w-6xl mx-auto">
        <div className="grid items-center gap-8 p-8 card glass rounded-2xl md:p-12 md:grid-cols-2">
          <div className="space-y-6">
            <div className="text-[var(--accent)] text-sm font-semibold tracking-widest uppercase">
              {t('manifestMeta')}
            </div>
            <h2 className="text-3xl font-bold leading-tight font-syne md:text-4xl lg:text-5xl">
              {t('manifestTitle')}
            </h2>
            <p className="text-[var(--muted)] text-lg leading-relaxed max-w-lg">
              {t('manifestText')}
            </p>
          </div>
          
          <div className="relative aspect-[4/3] rounded-xl overflow-hidden">
            <picture>
              <source
                type="image/avif"
                srcSet="/images/preview/Logodesigns/gaiamundilogo.jpg"
              />
              <img
                src="/images/preview/Logodesigns/gaiamundilogo.jpg"
                alt="Organic structures"
                className="object-cover w-full h-full"
                loading="lazy"
                decoding="async"
              />
            </picture>
          </div>
        </div>
      </div>
    </section>
  );
};